import { render, staticRenderFns } from "./tagImport.vue?vue&type=template&id=39675716&scoped=true&"
import script from "./tagImport.vue?vue&type=script&lang=js&"
export * from "./tagImport.vue?vue&type=script&lang=js&"
import style0 from "./tagImport.vue?vue&type=style&index=0&id=39675716&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39675716",
  null
  
)

export default component.exports